export default __webpack_public_path__ + "static/media/a037-student-t3-s3-4.f2f095e3.svg";